import {
  type DecoratedGameParticipant,
  type GameUserAddInput,
  type GameGroupAddInput,
  type GameData,
  type UnsavedGame,
  type BracketGameData,
  isDefined,
  UnsavedGameSchema,
} from '@terros/common'
import { shiftBracketStartDate, shiftStartDate } from '../bracket'

export const toAddParticipant = (participant: DecoratedGameParticipant): GameUserAddInput | GameGroupAddInput => {
  if (participant.type === 'user') {
    return {
      type: 'user',
      userId: participant.participantId,
      name: participant.name,
    }
  } else {
    return {
      type: 'group',
      users: participant.users.map((u) => u.participantId),
      name: participant.name,
    }
  }
}

export const toClonedGame = (game: GameData, newStartDate: number): UnsavedGame => {
  const newDates = getNewDates(game, newStartDate)
  const announceDate =
    isDefined(newDates.announceDate) && newDates.announceDate < Date.now() ? newStartDate : newDates.announceDate

  const cloned = UnsavedGameSchema.parse({
    ...game,
    ...newDates,
    announceDate,
    startDate: newStartDate,
    gameId: undefined,
    status: 'draft',
    name: `${game.name} (Copy)`,
  })

  if (cloned.gameType === 'raffle') cloned.winnersDrawn = false
  if (cloned.gameType === 'bracket') {
    cloned.rounds = cloned.rounds.map((round) => ({
      ...round,
      matches: round.matches.map(({ id, winnerGame, loserGame, order }) => ({ id, winnerGame, loserGame, order })),
    }))
  }
  return cloned
}

const getNewDates = (
  game: GameData,
  newStartDate: number
):
  | Pick<GameData, 'startDate' | 'announceDate' | 'endDate'>
  | Pick<BracketGameData, 'rounds' | 'endDate' | 'announceDate'> => {
  if (game.gameType === 'bracket') {
    return shiftBracketStartDate({ currentRounds: game.rounds, newStartDate, announceDate: game.announceDate })
  } else {
    return shiftStartDate(game, newStartDate)
  }
}
